@import "../../deprecated-globals/normalize";
@import "../../deprecated-globals/mixins";

:host {
  // margin-bottom: var(--spacing-comp-03);
  display: flex;
}

:host {
  .label {
    display: block;
    margin-bottom: 16px; //var(--spacing-lay-m);
  }
  .label:last-child {
    margin-bottom: 0;
  }
  input:focus + .checkmark {
    box-shadow: 0px 0px 0px var(--border-width-sm) var(--color-primary-active);
    border-color: var(--color-primary-active) !important  ;
  }
  input[disabled] {
    cursor: not-allowed;
  }
  input[disabled] + .checkmark {
    border-color: var(--darkGray) !important;
    pointer-events: none;
  }
  input[disabled] + .checkmark:after {
    border-color: var(--darkGray) !important;
  }
}

:host([inline]) .outer-wrapper {
  display: flex;
}
:host([inline]) .label {
  margin-inline-end: var(--spacing-comp-04);
  margin-bottom: 0;
}

:host {
  /* The label */
  .label {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    @include form-element-common-styles-label();
  }
  .label__required {
    @include form-element-common-styles-label-required();
  }

  /* Hide the browser's default checkbox */
  .label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .label input[on-focus] + .checkmark {
    box-shadow: inset 0px 0px 0px 1px var(--color-primary-active);
    border-color: var(--color-primary-active) !important;
  }
  .checkmark:focus {
    box-shadow: none;
  }

  /* Create a custom checkbox */
  .checkmark {
    display: inline-block;
    position: relative;
    margin-inline-end: var(--spacing-comp-02);
    height: var(--spacing-comp-04);
    width: var(--spacing-comp-04);
    //background-color: transparent;
    border-width: 1px; //var(--border-width-sm);
    border-style: solid; //var(--border-style-regular);
    border-radius: 3px; //var(--border-radius-md);
    border-color: var(--gray-04);
    box-sizing: border-box;
    flex-shrink: 0;
    background: var(--color-background);
    &.no-label {
      margin-inline-end: 0;
    }
  }

  /* When the checkbox is checked, add a blue background */

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .label input ~ .checkmark:after {
    display: block;
    border-color: transparent;
  }
  /* Show the checkmark when checked */
  .label input:checked ~ .checkmark:after {
    display: block;
    border-color: var(--color-primary-hover);
    @include ui-animation(border-color);
  }
  .label input:checked ~ .checkmark {
    border-color: var(--color-primary-hover);
  }

  /* Style the checkmark/indicator */
  .label .checkmark:after {
    left: 5px;
    top: 2px;
    width: 3px;
    height: 7px;
    border: solid;
    border-color: var(--color-primary-hover);
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}
/*indeterminate*/
:host([indeterminate]) .label input:checked ~ .checkmark:after {
  display: block;
  width: 10px;
  height: 2px;
  transform: rotate(0deg);
  border: 0;
  background-color: var(--color-primary-hover);
  left: 2px;
  top: 6px;
}
:host([disabled="true"]) label {
  cursor: not-allowed;
}
